export default __webpack_public_path__ + "static/media/car.e606a4c5.png";